import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { helpCenterSettingsNotFoundRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsNotFoundRoute.tsx';
import { NotFound } from './ui/not-found/index.tsx';

export const helpCenterSettingsNotFoundRouteEntry = createEntry(
	helpCenterSettingsNotFoundRoute,
	() => ({
		group: 'customer-service',
		component: NotFound,
		resources: [...jiraSpaResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsNotFoundRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsNotFoundRouteEntry',
			},

			enabled: true,
		},
	}),
);
